export var SERVICE_IDENTIFIER;
(function (SERVICE_IDENTIFIER) {
    SERVICE_IDENTIFIER["BATTLE_SERVICE"] = "BATTLE_SERVICE";
    SERVICE_IDENTIFIER["CARTRIDGES_SERVICE"] = "CARTRIDGES_SERVICE";
    SERVICE_IDENTIFIER["DEFENDERS_SERVICE"] = "DEFENDERS_SERVICE";
    SERVICE_IDENTIFIER["ENEMIES_SERVICE"] = "ENEMIES_SERVICE";
    SERVICE_IDENTIFIER["BONUS_SERVICE"] = "BONUS_SERVICE";
})(SERVICE_IDENTIFIER || (SERVICE_IDENTIFIER = {}));
